import React from 'react'
import {BrowserRouter, Route} from 'react-router-dom';

import {
    menuRoutes,
    newBolProfileRoutes,
    newAccountOpeningRoutes,
    digitalCreditRoutes,
    maintenanceRoutes,
    newCustodyAccountRoutes,
    kycRoutes,
    businessOnlineRoutes,
    remediationRoutes,
    globalMarketAccountRoutes,
    tpfaRoutes
} from "./routes";

import HomePage from '../components/HomePage';
import HierachyListPage from '../components/legalentity/HierachyListPage';
import EntityDetailsPage from '../components/legalentity/EntityDetailsPage';
import ConfirmProductPage from '../components/products/ConfirmProductPage';
import kyc from '../components/kyc/kyc';
import NavBar from '../components/Nav';
import requireAuth from '../components/LoggedIn';
import ConfirmApplicationPage from "../components/ConfirmApplicationPage";
import DelegateAuthorityPage from "../components/delegation/DelegateAuthorityPage";
import ConfigureRulesPage from "../components/rules/ConfigureRulesPage";
import RegulatoryInfoPage from "../components/legalentity/new entity/RegulatoryInfoPage"
import PageLoading from '../components/PageLoading'
import ConfirmAuthorisersPage from "../components/ConfirmAuthorisersPage";
import EntityLookupPage from '../components/legalentity/new entity/EntityLookupPage'
import NewEntityDetailsPage from '../components/legalentity/new entity/NewEntityDetailsPage';
import NewEntitykycPage from '../components/legalentity/new entity/NewEntitykycPage';
import OnBoardingPage from '../components/legalentity/new entity/OnBoardingPage'
import OnboardConfirmationPage from '../components/legalentity/new entity/OnboardConfirmationPage'
import ReportsPage from '../components/reports/ReportsPage'
import TrackingLandingPage from '../components/tracking/TrackingLandingPage'
import PaymentTrackingPage from '../components/tracking/PaymentTrackingPage'
import StepIndicatorNav from '../components/StepIndicatorNav';
import NewBolPage from '../components/bol/NewBolPage';
import ProfileProcessingOptionsPage from "../components/bol/ProfileProcessingOptionsPage";
import ChannelPage from "../components/bol/ChannelPage";
import BankAccountsPage from '../components/bol/BankAccountsPage';
import CustomerDetailsPage from '../components/bol/CustomerDetailsPage';
import UsersInfoPage from '../components/bol/UsersInfoPage';
import ApplicationCompletePage from "../components/bol/ApplicationCompletePage";
import DigitalCreditLandingPage from "../components/digitalCredit/DigitalCreditLandingPage";
import DigitalCreditPage from "../components/digitalCredit/DigitalCreditPage";
import CreditConfirmationPage from "../components/digitalCredit/CreditConfirmationPage";
import Footer from '../components/Footer'
import MaintenancePage from '../components/maintenance/MaintenancePage';
import SaveApplicationPage from "../components/SaveApplicationPage";
import ErrorMessage from '../components/ErrorMessage'
import BeneficialOwnerPage from '../components/bancs/BeneficialOwnerPage';
import CompletionPage from '../components/bancs/CompletionPage';
import ContactDetailsPage from '../components/bancs/ContactDetailsPage';
import AddressDetailsPage from '../components/bancs/AddressDetailsPage';
import InstructingPartyPage from '../components/bancs/InstructingPartyPage';
import AccountRelationsPage from '../components/bancs/AccountRelationsPage';
import AccountCashPurposePage from '../components/bancs/AccountCashPurposePage';
import NewCustodyAccount from '../components/bancs/NewCustodyAccount';
import KycMaintenance from '../components/kycMaintanence/KycMaintenance';
import SSICompletionPage from '../components/globalmarket/CompletionPage';
import ConfirmEntityPage from '../components/globalmarket/ConfirmEntityPage';
import SettlementInstructionsPage from '../components/globalmarket/SettlementInstructionsPage';
import CustomersPage from '../components/globalmarket/CustomersPage';
import LegalRemediation from '../components/legalRemediation/Legal-Remediation';
import Legals from '../components/legalRemediation/Legals';
import CustodyConfirmPage from '../components/bancs/CustodyConfirmPage';
import BusinessOnlinePage from '../components/businessOnline/BusinessOnlinePage';
import TransactionDetailsPage from '../components/businessOnline/TransactionDetailsPage';
import AuthorizationDetailsPage from '../components/businessOnline/AuthorizationDetailsPage';
import CompletePage from '../components/businessOnline/CompletePage';
import EbtcComplete from '../components/legalRemediation/EbtcComplete';
import TPFAStart from '../components/TPFA/TPFAStart';
import ThirdPartyDetails from '../components/TPFA/ThirdPartyDetails';
import TPFAComplete from '../components/TPFA/CompletePage'
import TokenReceiver from '../components/TokenReceiver';
import AdditionalProducts from '../components/TPFA/AdditionalProducts';
import KycEntity from '../components/kycMaintanence/KycEntity';
import KycCompletePage from '../components/kycMaintanence/KycCompletePage';
import {AccountSetupPage} from "../components/businessOnline/AccountSetupPage";
import BolContactInfo from "../components/businessOnline/BolContactInfo";

const AppRouter = (props) => (
    <BrowserRouter>
        <div style={{backgroundColor: 'white', flex: 1}}>
            <Route path="/" component={NavBar}/>
            <StepIndicatorNav {...props}/>
            <ScrollToTop/>
            <div style={{minHeight: '100vh'}}>
                <Route exact path="/" component={requireAuth(HomePage)}/>
                <Route exact path="/launch" component={TokenReceiver}/>

                <Route exact path={newAccountOpeningRoutes.newAccount} component={HierachyListPage}/>
                <Route path={newAccountOpeningRoutes.confirmdetails} component={EntityDetailsPage}/>
                <Route path={newAccountOpeningRoutes.confirmproduct} component={ConfirmProductPage}/>
                <Route path={newAccountOpeningRoutes.kyc} component={kyc}/>
                <Route path={newAccountOpeningRoutes.confirmauthorisers} component={ConfirmAuthorisersPage}/>
                <Route path={newAccountOpeningRoutes.confirmapplication} component={ConfirmApplicationPage}/>
                <Route exact path = {newCustodyAccountRoutes.custodyaccount} component={NewCustodyAccount}/>
                <Route path={newCustodyAccountRoutes.accountrelations} component={AccountRelationsPage}/>
                <Route path = {newCustodyAccountRoutes.accountcashpurpose} component = {AccountCashPurposePage}/>
                <Route path={newCustodyAccountRoutes.beneficialowner} component={BeneficialOwnerPage}/>
                <Route path={newCustodyAccountRoutes.addressdetails} component={AddressDetailsPage}/>
                <Route path={newCustodyAccountRoutes.contactdetails} component={ContactDetailsPage}/>
                <Route path={newCustodyAccountRoutes.instructingparty} component={InstructingPartyPage}/>
                <Route path={newCustodyAccountRoutes.confirmauthorisers} component={CustodyConfirmPage}/>
                <Route path={newCustodyAccountRoutes.complete} component={CompletionPage}/>

                <Route exact path={globalMarketAccountRoutes.entity} component={HierachyListPage}/>
                <Route exact path={globalMarketAccountRoutes.confirmentity} component={ConfirmEntityPage}/>
                {/* <Route exact path={globalMarketAccountRoutes.customers} component={CustomersPage}/> */}
                <Route exact path={globalMarketAccountRoutes.instructions} component={SettlementInstructionsPage}/>
                <Route path={globalMarketAccountRoutes.complete} component={SSICompletionPage}/>

                <Route exact path={menuRoutes.newEntity} component={OnBoardingPage}/>
                <Route exact path={menuRoutes.track} component={TrackingLandingPage}/>
                <Route path={`${menuRoutes.track}/transactions`} component={PaymentTrackingPage}/>
                <Route path="/onboard/lookup" component={EntityLookupPage}/>
                <Route path="/onboard/reginfo" component={RegulatoryInfoPage}/>
                <Route path="/onboard/details" component={NewEntityDetailsPage}/>
                <Route path="/onboard/kyc" component={NewEntitykycPage}/>
                <Route path={'/onboard/confirmed'} component={OnboardConfirmationPage}/>
                <Route path="/saveapplication" component={SaveApplicationPage}/>
                <Route path="/delegate" component={DelegateAuthorityPage}/>
                <Route path="/rules" component={ConfigureRulesPage}/>
                <Route path="/reporting" component={ReportsPage}/>
                <Route path="/new-custody-account" component={NewCustodyAccount}/>
                <Route exact path={kycRoutes.root} component={KycEntity}/>
                <Route path={kycRoutes.review} component={KycMaintenance}/>
                <Route path={kycRoutes.complete} component={KycCompletePage}/>

                <Route exact path={remediationRoutes.root} component={LegalRemediation}/>
                <Route path={remediationRoutes.legals} component={Legals}/>
                <Route path={remediationRoutes.complete} component={EbtcComplete}/>


                <Route exact path={businessOnlineRoutes.businessOnline} component={BusinessOnlinePage}/>
                <Route path={businessOnlineRoutes.transaction} component={TransactionDetailsPage}/>
                <Route path={businessOnlineRoutes.accountSetup} component={AccountSetupPage}/>
                <Route path={businessOnlineRoutes.authorization} component={AuthorizationDetailsPage}/>
                <Route path={businessOnlineRoutes.contactDetails} component={BolContactInfo}/>
                <Route path={businessOnlineRoutes.complete} component={CompletePage}/>

                <Route exact path={newBolProfileRoutes.bol} component={NewBolPage}/>
                <Route path={newBolProfileRoutes.details} component={CustomerDetailsPage}/>
                <Route path={newBolProfileRoutes.channel} component={ChannelPage}/>
                <Route path={newBolProfileRoutes.options} component={ProfileProcessingOptionsPage}/>
                <Route path={newBolProfileRoutes.accounts} component={BankAccountsPage}/>
                <Route path={newBolProfileRoutes.users} component={UsersInfoPage}/>
                <Route path={newBolProfileRoutes.complete} component={ApplicationCompletePage}/>

                <Route exact path={digitalCreditRoutes.root} component={DigitalCreditLandingPage}/>
                <Route exact path={digitalCreditRoutes.details} component={DigitalCreditPage}/>
                <Route exact path={digitalCreditRoutes.complete} component={CreditConfirmationPage}/>
                <Route exact path={maintenanceRoutes.root} component={MaintenancePage}/>
                <Route exact path={tpfaRoutes.root} component={TPFAStart}/>
                <Route path={tpfaRoutes.thirdParty} component={ThirdPartyDetails}/>
                <Route path={tpfaRoutes.complete} component={TPFAComplete}/>
            </div>
            <Footer/>
            <PageLoading/>
            <ErrorMessage {...props}/>
        </div>
    </BrowserRouter>
);

const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
};

export default AppRouter
